interface PresetBase {
  id: string;
  icon: string;
  color: string;
  prompt: string;
  bgColor: string;
  ringColor: string;
  shadowColor: string;
}

interface TypeConversionPreset extends PresetBase {
  targetType: "TF" | "TEST" | "FB" | "OE";
}

interface RegularPreset extends PresetBase {}

export const TYPE_CONVERSION_PRESETS: TypeConversionPreset[] = [
  {
    id: "convert_to_tf",
    icon: "✅",
    color: "lime",
    prompt: "preset:convert_to_tf",
    bgColor: "bg-lime-50 dark:bg-lime-900/30",
    ringColor: "ring-lime-500",
    shadowColor: "shadow-lime-500/20",
    targetType: "TF",
  },
  {
    id: "convert_to_test",
    icon: "📝",
    color: "fuchsia",
    prompt: "preset:convert_to_test",
    bgColor: "bg-fuchsia-50 dark:bg-fuchsia-900/30",
    ringColor: "ring-fuchsia-500",
    shadowColor: "shadow-fuchsia-500/20",
    targetType: "TEST",
  },
  {
    id: "convert_to_fb",
    icon: "🔲",
    color: "cyan",
    prompt: "preset:convert_to_fb",
    bgColor: "bg-cyan-50 dark:bg-cyan-900/30",
    ringColor: "ring-cyan-500",
    shadowColor: "shadow-cyan-500/20",
    targetType: "FB",
  },
  {
    id: "convert_to_oe",
    icon: "✍️",
    color: "orange",
    prompt: "preset:convert_to_oe",
    bgColor: "bg-orange-50 dark:bg-orange-900/30",
    ringColor: "ring-orange-500",
    shadowColor: "shadow-orange-500/20",
    targetType: "OE",
  },
] as const;

export const PRESETS: RegularPreset[] = [
  {
    id: "harder",
    icon: "🎯",
    color: "indigo",
    prompt: "preset:harder",
    bgColor: "bg-indigo-50 dark:bg-indigo-900/30",
    ringColor: "ring-indigo-500",
    shadowColor: "shadow-indigo-500/20",
  },
  {
    id: "make_easier",
    icon: "🎈",
    color: "red",
    prompt: "preset:make_easier",
    bgColor: "bg-red-50 dark:bg-red-900/30",
    ringColor: "ring-red-500",
    shadowColor: "shadow-red-500/20",
  },
  {
    id: "more_context",
    icon: "📚",
    color: "emerald",
    prompt: "preset:more_context",
    bgColor: "bg-emerald-50 dark:bg-emerald-900/30",
    ringColor: "ring-emerald-500",
    shadowColor: "shadow-emerald-500/20",
  },
  {
    id: "real_world_example",
    icon: "🌍",
    color: "blue",
    prompt: "preset:real_world_example",
    bgColor: "bg-blue-50 dark:bg-blue-900/30",
    ringColor: "ring-blue-500",
    shadowColor: "shadow-blue-500/20",
  },
  {
    id: "hint",
    icon: "💡",
    color: "amber",
    prompt: "preset:hint",
    bgColor: "bg-amber-50 dark:bg-amber-900/30",
    ringColor: "ring-amber-500",
    shadowColor: "shadow-amber-500/20",
  },
  {
    id: "simplify_language",
    icon: "🔍",
    color: "rose",
    prompt: "preset:simplify_language",
    bgColor: "bg-rose-50 dark:bg-rose-900/30",
    ringColor: "ring-rose-500",
    shadowColor: "shadow-rose-500/20",
  },
] as const;
